import type { Document } from '../api/authoring'

// The Page type's own fields, read by hand — and now the *only* thing in
// this client that is.
//
// Everything structural that used to live here is gone: `resolveSlots`,
// `unslottedChildren` and the `Placement`/`Slot` shapes were a Page's
// arrangement written out by hand, and `model/composition.ts` derives all
// of it from any type's fields schema instead.
//
// What is left is the title, and it is here because the authoring read
// has nowhere else to put it. A type contributes `Label` in Go — a site
// lists by it — but `Document` carries no label, so a screen that wants
// to head a page with its title has to know that a Page keeps one under
// `title`. Closing that means the label riding on a document the way
// `derived` already does, which is a change to the read and not to this
// file.
//
// Source of truth: internal/domain/component/types/page/page.go.

export interface PageSeo {
  description?: string
  keywords?: string
}

export interface PageFields {
  title?: string
  seo?: PageSeo
}

export function pageFields(document: Document): PageFields {
  return (document.fields ?? {}) as PageFields
}
